import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

// Wordmark + the A/I mark. The mark's "A" has no crossbar, so it is three
// skewed bars rather than glyphs; it flows after the word, so any word length works.
@Component({
  selector: 'app-brand-logo',
  templateUrl: './brand-logo.component.html',
  styleUrls: ['./brand-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandLogoComponent {
  @Input() text = 'SNF';

  // Any CSS length; a bare number is treated as px. Everything else scales off it.
  // Left unset it emits no inline style, so a host font-size rule can size it instead.
  @Input() size: string | number | null = null;

  @Input() lightColor: string | null = null;
  @Input() darkColor: string | null = null;
  @Input() ariaLabel: string | null = null;

  @HostBinding('attr.role') readonly role = 'img';

  @HostBinding('style.font-size') get fontSize(): string | null {
    if (this.size === null || this.size === '') {
      return null;
    }
    return typeof this.size === 'number' ? `${this.size}px` : this.size;
  }

  @HostBinding('attr.aria-label') get label(): string {
    return this.ariaLabel ?? `${this.text}AI`;
  }
}
